import React, { Fragment, useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import Loader from "../../shared/Loader";
import { errorToast, successToast } from "../../shared/Toast";
import user from "../../assets/images/user.png";
import Breadcrumb from "../common/breadcrumb";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/axios";
import { useSelector } from "react-redux";

const AddReward = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [rewardData, setRewardData] = useState({
    title: "",
    description: "",
    isActive: true,
  });
  const [imageForPayload, setImageForPayload] = useState(null);
  const [dummyImg, setDummyImg] = useState(user);

  const userType = localStorage.getItem("userType");
  const merchantIdFromStorage = localStorage.getItem("MerchantId");
  const { selectedMerchant: reduxSelectedMerchant } = useSelector((state) => state.merchant || {});
  const selectedMerchant = userType === "merchant" ? merchantIdFromStorage : reduxSelectedMerchant;

  const resetStates = () => {
    setRewardData({
      title: "",
      description: "",
      isActive: true,
    });
    setImageForPayload(null);
    setDummyImg(user);
  };

  const handleInputChange = (e, key) => {
    setRewardData((prev) => ({ ...prev, [key]: e.target.value }));
  };

  const handleStatusChange = (e) => {
    setRewardData((prev) => ({ ...prev, isActive: e.target.value === "true" }));
  };

  const _handleImgChange = (e) => {
    e.preventDefault();
    const image = e.target.files[0];
    setImageForPayload(image);

    let reader = new FileReader();
    reader.onload = () => {
      setDummyImg(reader.result);
    };
    reader.readAsDataURL(image);
  };

  const handleDiscard = () => {
    resetStates();
  };

  const gradientButtonStyle = {
    padding: "12px 24px",
    margin: "0 10px",
    borderRadius: "8px",
    background: "linear-gradient(135deg, #4A90E2 0%, #007BFF 100%)",
    color: "white",
    fontWeight: "600",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
    border: "none",
    cursor: "pointer",
    transition: "transform 0.2s, box-shadow 0.2s",
  };

  const handleMouseOver = (e) => {
    e.target.style.transform = "scale(1.1)";
    e.target.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.3)";
  };

  const handleMouseOut = (e) => {
    e.target.style.transform = "scale(1)";
    e.target.style.boxShadow = "0 4px 10px rgba(0, 0, 0, 0.2)";
  };

  const handleValidSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("Name", rewardData.title);
      formData.append("Points", rewardData.description);
      formData.append("is_active", rewardData.isActive);
      formData.append("dataType", "reward");

      if (!selectedMerchant || selectedMerchant === 'all') {
        errorToast("Please select a merchant.");
        setLoading(false);
        return;
      }
      formData.append("merchantId", selectedMerchant);
      if (imageForPayload) {
        formData.append("image1", imageForPayload, imageForPayload?.name);
      }

      const response = await axiosInstance.post("/api/reward/createReward", formData,
        {
          rawRequest: true,
        }
      );

      if (response.status === 200) {
        resetStates();
        successToast("Reward added successfully");
        navigate("/rewards/reward-list");
      } else {
        errorToast("Failed to add reward");
      }
    } catch (error) {
      console.error("Error adding reward:", error.response?.data || error);
      errorToast("Failed to add reward");
    } finally {
      setLoading(false);
    }
  };


  return (
    <Fragment>
      <Breadcrumb title="Add Reward" parent="Rewards" />
      <Container fluid={true}>
        {loading ? (
          <Loader />
        ) : (
          <Row>
            <Col sm="12">
              <Card>
                <CardHeader>
                  <h5>Add Reward</h5>
                </CardHeader>
                <CardBody>
                  <Row className="product-adding">
                    <Col xl="5">
                      <div className="add-product">
                        <Row>
                          <Col xl="3 xl-50" sm="6 col-3">
                            <div className="box-input-file">
                              <Input
                                className="upload"
                                type="file"
                                onChange={(e) => _handleImgChange(e)}
                              />
                              <img
                                alt="reward"
                                src={dummyImg} // Use dummyImg to show selected image
                                style={{ width: 50, height: 50 }}
                              />
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                    <Col xl="7">
                      <Form
                        className="needs-validation add-product-form"
                        onSubmit={handleValidSubmit}
                      >
                        <div className="form form-label-center">
                          <FormGroup className="form-group mb-3 row">
                            <Label className="col-xl-3 col-sm-4 mb-0">
                              Name:
                            </Label>
                            <div className="col-xl-8 col-sm-7">
                              <Input
                                className="form-control"
                                type="text"
                                required
                                value={rewardData.title}
                                onChange={(e) => handleInputChange(e, "title")}
                              />
                            </div>
                            <div className="valid-feedback">Looks good!</div>
                          </FormGroup>
                          <FormGroup className="form-group mb-3 row">
                            <Label className="col-xl-3 col-sm-4 mb-0">
                              Points:
                            </Label>
                            <div className="col-xl-8 col-sm-7">
                              <Input
                                className="form-control"
                                type="text"
                                required
                                value={rewardData.description}
                                onChange={(e) => handleInputChange(e, "description")}
                              />
                            </div>
                            <div className="valid-feedback">Looks good!</div>
                          </FormGroup>
                          <FormGroup className="form-group mb-3 row">
                            <Label className="col-xl-3 col-sm-4 mb-0">
                              Status:
                            </Label>
                            <div className="col-xl-8 col-sm-7">
                              <Input
                                type="select"
                                className="form-control"
                                value={rewardData.isActive}
                                onChange={handleStatusChange}
                              >
                                <option value={true}>Active</option>
                                <option value={false}>Inactive</option>
                              </Input>
                            </div>
                          </FormGroup>
                        </div>
                        <div className="offset-xl-3 offset-sm-4">
                          <Button
                            type="submit"
                            style={gradientButtonStyle}
                            onMouseOver={handleMouseOver}
                            onMouseOut={handleMouseOut}
                          >
                            Add
                          </Button>
                          <Button
                            onClick={handleDiscard}
                            type="button"
                            style={{
                              ...gradientButtonStyle,
                              background: "linear-gradient(135deg, #FF6B6B 0%, #FF0000 100%)",
                            }}
                            onMouseOver={handleMouseOver}
                            onMouseOut={handleMouseOut}
                          >
                            Discard
                          </Button>
                        </div>
                      </Form>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </Container>
    </Fragment>
  );
};

export default AddReward;